import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {year} Vincent Le. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
